import 'source-map-support/register';

// Builder
export createBuilder from './builder';

// Helpers
export getResolvePath from './helpers/get-resolve-path';

// Configuration
export configFile from './config/roc.config.js';
export { baseConfig } from './helpers/config';
export { metaConfig } from './helpers/config';
